import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import { Form, Modal, Input, Select, AutoComplete, Icon, message, Tooltip } from 'antd'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/jobs'
import { actions as companiesActions } from '../../redux/modules/companiesActions'
import { actions as jobActions } from '../../redux/modules/jobDetails'
import 'react-table/react-table.css'
import history from '../../history'
import moment from 'moment'
import { convertToOption, filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import _ from 'lodash'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import OrganizationQuickAdd from '../../components/organization//OrganizationQuickAdd'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option
const propTypes = {}

class jobs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      firstLoad: true,
      activeJobs: []
    }

    this.props.jobsRefresh({
      next: (payload, err) => {
        if (!err && payload && payload.data) {
          const activeJobs = payload.data.filter(el => el.real_status.toLowerCase() === 'active')
          this.setState({ activeJobs })
        }
      }
    })
    this.props.getAllCompanies()
  }

  componentDidMount() {
    if (this.props.match.params.parentJobId) {
      this.props.fetchJobDetails({
        jobId: this.props.match.params.parentJobId
      })
      this.setState({
        parentJobId: this.props.match.params.parentJobId
      })

      this.handleClickAddJob()
    }
  }

  handleClickAddJob = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  getSelectedOrganization = value => {
    const organizations =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    const selectedOrganization = organizations.find(organization => organization.name === value)
    return selectedOrganization ? +selectedOrganization.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.organization_id = this.getSelectedOrganization(values.organization_id)
      values.parent_job_id = this.state.parentJobId ? this.state.parentJobId : null

      this.props.createJob({
        content: values,
        userId: this.props.authentication.user.userId
      })

      form.resetFields()
      message.success('Job created.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.authentication.user.userId
    })
    setTimeout(() => {
      this.props.getAllCompanies()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.companiesActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.companiesActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  render() {
    const { payload } = this.props.jobs
    const { getFieldDecorator } = this.props.form
    var parentJob = {}
    if (this.state.parentJobId && payload && payload.data) {
      const filteredJobs = payload.data.filter(
        job => job.id === parseInt(this.state.parentJobId, 10)
      )
      if (filteredJobs.length > 0) {
        parentJob = filteredJobs[0]
      }
    }
    const allCompanies =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
            organizartionType={'Client'}
          />
          <Modal
            visible={this.state.modalVisible}
            title="Create a new job"
            okText={'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={800}
            maskClosable={false}
          >
            <Form layout="vertical">
              <div className="row">
                <div className="col-6">
                  <FormItem label="Job Type">
                    {getFieldDecorator('job_type', {
                      initialValue: parentJob.type,
                      rules: [
                        {
                          required: true,
                          message: 'Job type cannot be blank.'
                        }
                      ]
                    })(
                      <Select>
                        <Option value="New Construction">New Construction</Option>
                        <Option value="Modernization">Modernization</Option>
                        <Option value="Maintenance/Service">Maintenance/Service</Option>
                        <Option value="Repair">Repair</Option>
                        <Option value="Specialty">Specialty</Option>
                        <Option value="Material Sale">Material Sale</Option>
                      </Select>
                    )}
                  </FormItem>
                </div>
                <div className="col-6">
                  {this.state.parentJobId && (
                    <FormItem label="Parent Job ID">
                      {getFieldDecorator('parent_job_id', {
                        initialValue: this.state.parentJobId
                      })(<Input disabled />)}
                    </FormItem>
                  )}
                </div>
              </div>
              <FormItem label="Organization">
                {getFieldDecorator('organization_id', {
                  initialValue: parentJob.organization_id ? '' + parentJob.organization_id : '',
                  rules: [
                    {
                      required: true,
                      message: 'Must choose an organization.'
                    }
                  ]
                })(
                  <AutoComplete
                    dataSource={convertToOption(allCompanies)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    placeholder="Search for some Company"
                    width={320}
                    onBlur={this.handleBlurOrganization}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
              <FormItem label="ZIP Code">
                {getFieldDecorator('zip', {
                  initialValue: parentJob.zip,
                  rules: [
                    {
                      required: true,
                      message: 'Zip cannot be blank.'
                    }
                  ]
                })(<Input type="number" />)}
              </FormItem>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Street Address">
                    {getFieldDecorator('address1', {
                      initialValue: parentJob.address1,
                      rules: [
                        {
                          required: true,
                          message: 'Street address cannot be blank.'
                        }
                      ]
                    })(<Input placeholder="Street and number, P.O. box, C/o." />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="City">
                    {getFieldDecorator('city', {
                      initialValue: parentJob.city,
                      rules: [
                        {
                          required: true,
                          message: 'City cannot be blank.'
                        }
                      ]
                    })(<Input placeholder="City" />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Street Address (cont.)">
                    {getFieldDecorator('address2', { initialValue: parentJob.address2 })(
                      <Input placeholder="Apartment, suite, unit, building, floor, etc." />
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="State">
                    {getFieldDecorator('state', {
                      initialValue: parentJob.state,
                      rules: [
                        {
                          required: true,
                          message: 'State cannot be blank.'
                        }
                      ]
                    })(<Input placeholder="State" />)}
                  </FormItem>
                </div>
              </div>

              <FormItem label="Project Name">
                {getFieldDecorator('name', {
                  initialValue: parentJob.name,
                  rules: [
                    {
                      required: true,
                      message: 'Project name cannot be blank.'
                    }
                  ]
                })(<Input placeholder="Your project name..." />)}
              </FormItem>
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: parentJob.description,
                  rules: [
                    {
                      required: true,
                      message: 'Note description cannot be blank.'
                    }
                  ]
                })(<TextArea placeholder="Describe your project..." rows={4} />)}
              </FormItem>
            </Form>
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/jobs">Jobs</Link>
                </li>
              </ol>
            </nav>
            <h2>Recent Jobs</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Jobs
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;
                  <div onClick={this.handleClickAddJob} className="addJobLabel">
                    NEW JOB
                  </div>
                </div>
              </div>
              <ReactTable
                data={
                  this.state.firstLoad && this.state.activeJobs.length > 0
                    ? this.state.activeJobs
                    : payload.data
                }
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e =>
                    history.push(
                      `/jobView/${rowInfo.original.id}/${rowInfo.original.type.replace('/', '-')}`
                    )
                })}
                filterable
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Job',
                        id: 'name',
                        accessor: 'name',
                        Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>,
                        minWidth: 220,
                        filterMethod: (filter, row) => {
                          return row._original.name
                            .toLowerCase()
                            .includes(filter.value.toLowerCase())
                        }
                      },
                      {
                        Header: 'Type',
                        id: 'type',
                        accessor: 'type',
                        Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>,
                        minWidth: 110,
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          return filter.value === row.type
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'all'}
                          >
                            <option value="all">All</option>
                            <option value="Maintenance/Service">Maintenance/Service</option>
                            <option value="Material Sale">Material Sale</option>
                            <option value="Modernization">Modernization</option>
                            <option value="New Construction">New Construction</option>
                            <option value="Repair">Repair</option>
                            <option value="Specialty">Specialty</option>
                          </select>
                        )
                      },
                      {
                        Header: 'Company',
                        id: 'company_name',
                        accessor: 'company_name',
                        Cell: d => (
                          <Tooltip title={d.original.company_name}>
                            {d.original.company_name}
                          </Tooltip>
                        )
                      },
                      {
                        Header: 'Contact',
                        id: 'contact',
                        accessor: d => {
                          const r = d.contact_first_name
                            ? `${d.contact_first_name} ${d.contact_last_name}`
                            : 'No Contact Assigned'
                          return r
                        },
                        Cell: d => {
                          const r = d.original.contact_first_name
                            ? `${d.original.contact_first_name} ${d.original.contact_last_name}`
                            : 'No Contact Assigned'
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Status',
                        accessor: 'real_status',
                        Cell: row => {
                          return (
                            <span>
                              <span
                                style={{
                                  color: row.original.status === 'active' ? '#57d500' : '#ffbf00',
                                  transition: 'all .3s ease'
                                }}
                              >
                                &#x25cf;
                              </span>
                              {row.original.status}
                            </span>
                          )
                        },
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          if (filter.value === 'active')
                            return row.real_status.toLowerCase() === 'active'
                          return filter.value.toLowerCase() === row._original.status.toLowerCase()
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'active'}
                          >
                            <option value="all">All</option>
                            <option value="active">Active</option>
                            <option value="design">Design</option>
                            <option value="work in progress">Work in progress</option>
                            <option value="complete">Complete</option>
                            <option value="inactive">Inactive</option>
                            <option value="manufacturing">Manufacturing</option>
                            <option value="dead">Dead</option>
                          </select>
                        ),
                        minWidth: 120
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        Cell: row => <span>{moment.utc(row.value).format('M/D/YYYY')}</span>,
                        minWidth: 100
                      }
                    ]
                  }
                ]}
                defaultFilterMethod={filterCaseInsensitive}
                onFilteredChange={filtered => {
                  if (filtered.filter(filter => filter.id === 'real_status').length > 0) {
                    this.setState({ firstLoad: false })
                  }
                }}
                defaultPageSize={10}
                className="-striped -highlight"
                defaultSorted={[
                  {
                    id: 'id',
                    desc: true
                  }
                ]}
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { jobs, companiesActions, organizationsActions, jobActions, authentication },
  ownProps
) => ({
  jobs,
  companiesActions,
  organizationsActions,
  jobActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, actions, companiesActions, jobActions, organizationsActions),
    dispatch
  )
})

jobs.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(jobs)))



// WEBPACK FOOTER //
// ./src/containers/job/jobs.js